var Marionette = require('marionette'),
    fvChannel = require('glRadio').channel('FV'),
    Util = require('../../FV/util'),
    $ = require('jquery'),
    blindForward = Util.blindForward;


/*
 *
 * Post making the state change
 * Really on same level as channel -- though deals directly with state changes
 * request, reply to channel
 * Context is the viewer instance (subapp)
 *
 * */


module.exports = {

    //note: doesn't imply is 'visible' -- different event for that
    viewerLoaded: function(state) {

        var viewMode = state.viewMode();

        this.command( 'setPageNavigationHotkeys', viewMode );

        if (state.viewMode() === 'pdf') {

            this.request('allowPdfToLoad') && this.request('pdfModeContainer').loadPDFDocument();

        } else if (viewMode === 'page') {

            this.command('createPageModeView', {src: 'viewerRendered'});  // this could be a deferred ..

            // Note: view mode will always be set to page first if create new redaction on entry,
            // and the command must be called after the canvas has already been created.

            this.settings.createNewRedactionOnEntry() && this.command('createNewRedaction');

        } else if (viewMode === 'document') {

            /**
             * Do this before when 'setInitialScale is called, the subPanels aren't yet open so the calculation if off --
             * temp workaround; years later needs inspection.
             * TODO: overlap with entry on viewModechange, others?
             */
            state.setScale();
            this.command('checkForDocModeImagesInView');
            this.command('handleDocModeImgPrefetching', this.request('currentPage')); // Quick fix on load -- otherwise only called on pg change

            // Would want thumbs here too, but now there are never open on load -- this may change
        }

        if ( this.request('docHasNoRenderablePgs') ) {
            this.commandOn('layout', 'toggleRotateEnabled', true); //disable -- don't check fn (current Page will be null)
        }

        // Really want after show of layoutView but this should cache it -- want a resizeEvent to update the layout
        this.command('updateAfterViewerResize');

        var onLoad = this.request('settings').get('onLoad'); //TODO: better mediate (radio on settings?)
        onLoad && onLoad.call(this, this);


    },
    /* note: for now options is for fromFullScreenToggle, and now maybe fromRotation */
    scaleChange: function(sm, scale, options) {

        this.commandOn( ['viewModes', 'layout'], 'changeScale', sm.get('mode'), scale, sm.previous('scale'), sm, options );

    },
    scaleTypeChange: function() {

        this.state.viewMode() === 'page' &&
            this.commandOn('viewModes', 'scaleTypeChange');

    },
    changeActiveNote: function(state, note, options) {

        // Always ensure open -- eg won't be if called from header bar (it's closed by default)
        this.trigger( 'vChannel:openToSubPane', this.request('getLayout').rightSideModel, 'notes' );

        var isMultiDoc = this.request('documents').length > 1;
        isMultiDoc && this.command('toggleMultiDocInterfaces', !note);

        var prNote = state.previous('activeNote');

        var commandOptions =  _.extend( options, {
            prNote: prNote,
            viewMode: state.get('viewMode'),
            disableRotation: state.disableRotation()
        });

        // Toggle 'Edit Mode' on the Canvas -- only do if drawable note
        // With find and redact -- maybe we call toggleDrawing mode ..
        // Logic could but set prior in API
        if ( note && note.isDrawable() ) {

            this.commandOn( 'viewModes', 'activeNoteChange', note, commandOptions );

        } else {

            if ( prNote && prNote.isDrawable() ) {
                this.commandOn( 'viewModes', 'activeNoteChange', note, commandOptions );
            }
        }

        this.commandOn( ['notes', 'layout'] , 'activeNoteChange', note, commandOptions );

    },
    changeExpandedNote: function( state, note ) {

        this.commandOn(['viewModes', 'notes', 'layout'], 'expandedNoteChange', note, {
            prNote: state.previous('expandedNote'),
            disableRotation: state.disableRotation()
        });

    },
    changeActiveNoteSubType: function(state, noteType, options) {

        this.commandOn(['viewModes', 'notes'], 'activeNoteSubTypeChange', noteType, _.extend( options, {
            activeNote: state.activeNote()
        }));

    },

    changeCurrentPage: function(state, page, options) {

        state.set({ fullPageModel: this.request('getNewFullPageModelFromDocModePage', page) });

        // Want this always called on doc mode even if not loaded --
        // so max image loaded can't exceed threshold (though may not yet exist)
        // Will only call on docModeView if it exists
        this.commandOn( 'viewModes', 'docModeChangePage', {
            loadImages: state.loadImages()
        });


        if (options.initialLoad)  //at first, just set the models
            return;


        // Should have these results of the trigger below ... would be things clearer maybe
        this.command('createPageModeView', {
            src: 'pageChange'
        });

        this.command( 'goToThumbnail', page );

        this.commandOn(['fullText', 'notes', 'layout', 'findAndRedact'], 'changePage', {
            pageNum: page.get('number'),
            page: page,
            activeNote: state.activeNote(),
            isFirstPg: state.isFirstPage(),
            isLastPg: state.isLastPage(),
            disableScaling: this.request('disableScaling'),
            disableRotation: state.disableRotation()
        });

    },
    /*  Doc Mode Container may now not exists; they other modes should always be present for now */
    changeViewMode: function (state, mode, options) {

        var prevMode = state.previous('viewMode'),
            docModeContainer = this.request('docModeContainer'),
            pgModeContainer = this.request('pgModeContainer'),
            pdfModeContainer = this.request('pdfModeContainer');

        this.commandOn( 'layout', 'toggleHeaderViewMode', mode, prevMode );
        this.commandOn( 'viewModes', 'setViewMode', mode, prevMode );

        this.command( 'setPageNavigationHotkeys', mode );

        switch (mode) {
            case 'document':

                // perhaps we want a layout 'refresh' ( see onLoad )
                setTimeout( state.setScale, 0 );
                blindForward( docModeContainer, 'scrollToCurrentPageTop' );
                this.command('checkForDocModeImagesInView');
                break;

            case 'page':

                /* Note: could already be created */
                this.command('createPageModeView', {src: 'modeChangeEntry'});
                break;

            case 'pdf':

                // Don't ever allow thumbnail pane to show in this mode
                var leftSideModel = this.request('getLayout').leftSideModel;
                leftSideModel.isSubPanelOpen('thumbs') && leftSideModel.close();

                if (!state.get('pdfRendered')) {
                    // should write enter/exit fn for the mode containers
                    //(if rotated and re-entering, hide the pdf that is currently showing while the other loads) -- starts invisible anyway on load
                    pdfModeContainer.ui.pdfWrapper.addClass('invisible');
                    this.request('allowPdfToLoad') && pdfModeContainer.loadPDFDocument();  //don't want to reload, just do this
                }
                break;
        }

        this.commandOn( 'notes', 'viewModeChange', mode, _.extend( options, {
            pagesExist: this.activeDocument.pageCollection.length > 0,
            currentPage: state.currentPage(),
            activeNote: state.activeNote(),
            previousMode: prevMode
        }));

    },
    toggleLoadImages: function(state, loadImages) {

        if (!loadImages)
            return;

        /* Note, thumbnails sidepane, on open checkInView triggered
            -- but the individual thumbs aren't listening if loadImages was false -- so here, make them no listen */
        this.commandOn( 'thumbNails', 'listenForThumbsToBeInView' );

        // Trigger image loading in the current mode -- don't do across all modes
        switch ( state.viewMode() ) {

            case 'pdf':
                this.request('allowPdfToLoad') && this.request('pdfModeContainer').loadPDFDocument();
                break;

            case 'page':
                this.command('createPageModeView', {src: 'toggleLoadImages'});
                break;

            case 'document':

                // Should combo logic for loading inview as well as the page queue
                this.command('checkForDocModeImagesInView');

                // DVBC-1010 -- FIXES, but then breaks toggle full screen (may break others)
                // this.command('handleDocModeImgPrefetching', this.request('currentPage'));
                break;
        }

    },
    /**
     *  Note: intertwined with set scale
     *  DOM element changes will trigger window resize event, causing recursion with setScale
     **/
    toggleFullScreenMode: function (state, isFullScreen) {

        /**
         * el is detached, then retached ...
         * When detached from dom, scrollTop will be set to the top
         * Should incorporate method for all div's with overflow -- now just this one.
         */
        var esScrollRatio = this.requestOn('fullText', 'vChannel:scrollTopRatio');

        this.command('mainView.toggleFullScreen');


        this.commandOn('layout', 'toggleFullScreen', isFullScreen);

        // Note: a sync re-appending to the DOM
        this.commandOn('fullText', 'vChannel:setScrollPosition', esScrollRatio);

        // fromFullScreenToggle: indicator that we're coming from full screen mode: page, newScale, newScaleType (s/b object)
        // ( I don't believe used anymore )
        this.command( 'setScale', undefined, undefined, {
            fromFullScreenToggle: true
        });

        // Note: ( could be superflous if the scale changed but no large performance hit )
        this.command( 'repositionShapeDialog' );

    },

    panelResizingChange: function (st, val) {
        this.command('forceClosePageActionDropdownMenus');
        this.commandOn('notes', 'togglePanelResize', val);
    },



    // TODO: for now we don't want this ... get feedback; I think maybe only text only mode

    togglePageTextMode: function( state, showPageTextMode ) {

        // Always trigger on Doc Mode --- views are created but may not yet be loaded.
        // TODO: actually, maybe only if loaded or on entry into the mode?  Could be processing intensive

        if ( this.request('includeDocumentMode') ) {

            var docModePages = this.request('activeDocPages');
            docModePages.each( function(page) {
                page.trigger('pageView:toggleTextLayer', showPageTextMode );
            });

        }


        // Even if not in mode or page mode's view hasn't been loaded, full page model should exist
        // Always trigger ( eg user toggles in Doc/PDF mode, we want it updated upon re-entry
        state.fullPageModel().trigger('pageView:toggleTextLayer', showPageTextMode);

    },

    // See comments from togglePageTextMode: mostly same strategy ...
    toggleTextOnlyMode: function( state, textOnlyMode ) {

        if ( this.request('includeDocumentMode') ) {

            var docModePages = this.request('activeDocPages');
            docModePages.each( function(page) {
                page.trigger('pageView:toggleTextOnlyMode', textOnlyMode );
            });

        }

        state.fullPageModel().trigger('pageView:toggleTextOnlyMode', textOnlyMode );

    }



};


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/state/callback.js
 ** module id = 106
 ** module chunks = 0
 **/